<header
  class="header-main d-flex align-items-center justify-content-between"
  [class.expanded]="isExpanded"
>
  <a class="header_logo" routerLink="">(DEMO CONCEPT) SEC ISA, Rules & Amendments Digital Platform</a>
  <div class="dropdown user-dropdown">
    <a
      href="#"
      class="dropdown-toggle"
      id="dropdownUser2"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <img
        src="https://github.com/mdo.png"
        alt=""
        width="32"
        height="32"
        class="rounded-circle me-2"
      />
      <span>{{user.firstName +' '+ user.lastName}}</span>
    </a>
    <ul
      class="dropdown-menu shadow animated-dropdown"
      aria-labelledby="dropdownUser2"
    >
      <li><a class="dropdown-item" href="profile"><i class="bi bi-person"></i>Profile</a></li>
      <li><a class="dropdown-item" href="login" (click)="signout()"><i class="bi bi-box-arrow-in-right"></i>Sign out</a></li>
    </ul>
  </div>
</header>
